<template>
  <div>
      <div class="container">
        <h1 class="page-header">
               <span>Our
                 <span class="orange-link">Story</span></span>
          <hr/>
        </h1>
        <div class="title-intro">
          <p>Friday Financial Services is a Suffolk based Mortgage Brokerage, with a client bank covering the whole of the UK. With a combined experience of over 34 years, our team of experienced mortgage consultants offer whole of market advice, treating each client as an individual and tailoring specialist advice to meet the needs and demands of our customers. Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
        </div>
        <h2>Meet the Advisers</h2>
        <hr />
        <div class="team-member">
          <h3>Andrew Friday DipFA – Founder and Director</h3>
          <p>Founder of Friday Financial Services, Andrew is a professionally qualified financial adviser who has over 17 years’ experience within the industry. After spending many years working within high street banks, Andrew’s ambition and drive led to him creating Friday Financial Services in 2015. Andrew’s innovative and determined personality is the key to ensure that Friday Financial retains its title as Lowestoft's Top Rated Mortgage Firm.</p>
          <img src="~@/assets/images/staff-images/andrew.png" alt="Andrew Friday Image"/>
        </div>
        <div class="team-member">
          <h3>Lauren O’Dwyer DipFA – Financial Adviser</h3>
          <p>Lauren joined Friday as an Administrator in March 2020 and quickly discovered her passion for helping clients achieve their property goals. Determined to progress her career, she gained her CeMAP qualification and became a Mortgage Adviser in 2021.</p>
          <p>Known for her fantastic customer service and problem-solving approach, Lauren has developed a strong reputation for helping clients with complex credit histories, self-employed applications, and intricate income structures. She also has extensive experience supporting clients purchasing new-build properties, ensuring a smooth journey from application to completion.</p>
          <p>In 2025, Lauren achieved the Diploma for Financial Advisers (DipFA) qualification, becoming a qualified Pension Adviser and expanding the range of support she can offer her clients.</p>
          <p>Outside of work, Lauren is a devoted mum to Mylie and enjoys spending quality time with her partner, Luke. Her commitment, professionalism, and client-focused approach make her a valued member of the Friday team.</p>
          <img src="~@/assets/images/staff-images/lauren.png" alt="Lauren O'Dwyer Image"/>
        </div>
        <div class="team-member">
          <h3>Lily Buckingham – Mortgage Administrator</h3>
          <p>Lily is the newest member of our team and plays a vital role in ensuring every client's mortgage journey runs as smoothly as possible. As Mortgage Administrator, she provides essential support throughout the process, keeping clients informed at every stage and liaising closely with solicitors, estate agents, lenders, and other parties involved.</p>
          <p>Known for her proactive approach and attention to detail, Lily helps coordinate applications, manage documentation, and resolve any challenges that may arise along the way. Her dedication to delivering excellent service ensures clients feel supported and confident from application through to completion.</p>
          <img src="~@/assets/images/staff-images/lily.jpg" alt="Lily Buckingham Image"/>
        </div>
      </div>
      <div class="cta">
        <div class="container">
          <div class="row d-flex align-items-center justify-content-between">
            <h2 class="mb-0 d-flex justify-content-center">
              <strong>Get In Touch</strong>
            </h2>
            <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
            <div class="d-flex justify-content-end align-items-center">
              <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name : "selling-with-us"
}
</script>



<style lang="css">


</style>



// WEBPACK FOOTER //
// src/components/pages/OurStory.vue